export enum DashboardSortColumnEnum {
  Amount = 'amount',
  Value = 'value',
}
